module.exports = __webpack_public_path__ + "img/icon-pdf.4a1bce6f.svg";